function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgRain2 = function SvgRain2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B9C8"
    },
    d: "M426.208,168.036c-1.12,0-42.648,0-42.648,0c0.744-8,1.24-13.624,1.256-18.408 c0.128-42.672-28.36-82.424-70.032-91.6c-23.752-5.232-46.424-2.6-65.184,7.528C226.712,31.492,188.792,7.9,145.328,5.244 c-5.592-0.768-11.256-1.528-17.056-1.528C57.432,3.708,0,62.82,0,135.876c0,38.072,15.688,72.232,40.648,96.368 c22.072,24.488,52.72,40.272,89.008,42.904c0,0,295.432,1.448,296.552,1.448c29.712,0,53.792-22.288,53.792-54.28 S455.912,168.036,426.208,168.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M392.48,288.036c-0.992,0-37.672,0-37.672,0c0.656-8,1.096-7.976,1.104-12.2 c0.112-37.696-25.048-70.776-61.856-78.888c-20.984-4.624-41.008-1.28-57.584,7.664c-20.216-30.088-53.72-50.424-92.104-52.768 c-4.944-0.68-9.944-1.096-15.064-1.096C66.728,150.74,16,203.084,16,267.62c0,33.632,13.856,63.864,35.904,85.184 c19.496,21.632,46.568,35.608,78.624,37.936c0,0,260.968,1.296,261.96,1.296c26.24,0,47.52-23.736,47.52-52 C440,311.772,418.728,288.036,392.48,288.036z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#92C7D3"
    },
    d: "M129.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C135.448,474.852,132.76,476.284,129.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    style: {
      fill: "#92C7D3"
    },
    d: "M177.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C183.448,474.852,180.76,476.284,177.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2",
    style: {
      fill: "#92C7D3"
    },
    d: "M33.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C39.448,474.852,36.76,476.284,33.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3",
    style: {
      fill: "#92C7D3"
    },
    d: "M81.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C87.448,474.852,84.76,476.284,81.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4",
    style: {
      fill: "#92C7D3"
    },
    d: "M225.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C231.448,474.852,228.76,476.284,225.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5",
    style: {
      fill: "#92C7D3"
    },
    d: "M273.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C279.448,474.852,276.76,476.284,273.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6",
    style: {
      fill: "#92C7D3"
    },
    d: "M321.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C327.448,474.852,324.76,476.284,321.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7",
    style: {
      fill: "#92C7D3"
    },
    d: "M369.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C375.448,474.852,372.76,476.284,369.992,476.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8",
    style: {
      fill: "#92C7D3"
    },
    d: "M417.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.2-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C423.448,474.852,420.76,476.284,417.992,476.284z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M129.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C135.448,474.852,132.76,476.284,129.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M177.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C183.448,474.852,180.76,476.284,177.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M33.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C39.448,474.852,36.76,476.284,33.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M81.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C87.448,474.852,84.76,476.284,81.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M225.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C231.448,474.852,228.76,476.284,225.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M273.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C279.448,474.852,276.76,476.284,273.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M321.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C327.448,474.852,324.76,476.284,321.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M369.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C375.448,474.852,372.76,476.284,369.992,476.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8_1_",
    style: {
      fill: "#92C7D3"
    },
    d: "M417.992,476.284c-1.36,0-2.736-0.344-3.992-1.072 c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496c2.2-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928 l-28,48.496C423.448,474.852,420.76,476.284,417.992,476.284z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRain2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rain-2.5ee170bc.svg";
export { ForwardRef as ReactComponent };